<template>
<!-- 测评结果 -->
  <div class="evaluation-result">
    <div id="pdfDom">
      <div class="result-section">
        <p class="txt-c title-set m-t-50">{{testName}}</p>
        <p class="txt-c test-report m-t-20">测评报告</p>
        <p class="test-report m-t-20" style="font-weight: normal; text-indent: 32px;">
          {{resultsData.reportDesc}}
        </p>
        <!-- 图表设置 -->
        <div v-if="resultsData.isShowTableSet">
          <p class="txt-c title-set m-t-20">{{resultsData.tableSet.tableTitle}}</p>
          <div id="histogram" class="histogram-section" :class="{'histogram-section-radar': this.resultsData.tableSet.tableName==1}">
          </div>
        </div>
        <div v-if="resultsData.isShowTableResult" style="display: flex; justify-content: center;">
          <p class="txt-c summary-title m-t-20">{{resultsData.tableResult.upContent}}：</p>
          <p class="txt-c summary-title m-t-20" style="font-weight: 600">{{resultsData.tableResult.downContent}}</p>
        </div>

        <div v-if="resultsData.isShowTopicReportList">
          <p class="txt-c title-set m-t-20">{{resultsData.topicReport.titleWarning}}</p>

          <div class="chart-summary m-t-20" v-for="(item, index) in resultsData.topicReport.topicReportList">
            <split-block :split="item.formatTitle"></split-block>
            <div class="summary-txt" v-if="item.content" v-html="item.content"></div>
          </div>
        </div>


        <div class="p-t-20" v-if="resultsData.isShowReportResult">
          <p class="txt-c title-set m-t-20">{{resultsData.moreSuggestTitle}}</p>
          <div class="chart-summary m-t-20" v-for="item in resultsData.moreSuggest">
            <split-block :split="item.formatTitle"></split-block>
            <div class="summary-txt" v-if="item.content" v-html="item.content"></div>
          </div>
        </div>

        <div class="m-t-20" v-if="resultsData.isShowReportResult">
          <split-block :split="resultsData.reportResult.formatTitle" :border="false"></split-block>
          <div style="line-height: 24px;" v-html="resultsData.reportResult.content"></div>
        </div>
      </div>
    </div>
    <div class="btn-box">
      <el-button id="renderPdf" ref="renderPdf" type="primary" v-on:click="getPdf('#pdfDom')" >下载报告</el-button>
      <el-button type="primary" v-on:click="dialogVisible = true" >预约咨询</el-button>
    </div>


    <div class="right-btn-box">
      <el-button style="background-color: #7870b6;" circle @click="goEvaluationIndex()">返回</el-button>
    </div>

    <el-dialog
      title="咨询预约电话(微信同号)"
      :visible.sync="dialogVisible"
      width="30%">
      <div class="consult-content">
        <p>西安分中心：181 8913 5703</p>
        <p>汉中分中心：130 9392 0312</p>
        <p>宝鸡分中心：153 0917 5208</p>
        <p>榆林分中心：138 9220 4811</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="text-center">
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </div>
      </span>
    </el-dialog>

  </div>

</template>

<script>
import { request } from "@/util/request"
import splitBlock from './components/split-block'
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";

export default {
  name: "evaluationDetail",
  components: {
    splitBlock
  },
  data () {
    return {
      fullscreenLoading: true,
      testId: "",
      testName: "",
      chartType: [
        {
          label: "雷达图",
          value: "1"
        },
        {
          label: "条形图",
          value: "2"
        }
      ],
      chartTheme: [
        {
          label: "灰色系",
          value: "1"
        },
        {
          label: "蓝色系",
          value: "2"
        },
        {
          label: "橙色系",
          value: "3"
        },
        {
          label: "红色系",
          value: "4"
        },
        {
          label: "绿色系",
          value: "5"
        },
      ],
      chartThemeColor: ['#37A2DA', '#dd6b66', '#c23531', '#4EA397', '#8D98B3'],  // 图表色系
      sortType: [
        {
          label: "按题组编号排序",
          value: "1"
        },
        {
          label: "按题组得分从高到低排序",
          value: "2"
        }
      ],
      resultsData: {
        id: "",
        testId: "",
        reportDesc: "",
        isShowReportDesc: 0,
        tableSet: {},
        isShowTableSet: 0,
        tableResult: {},
        isShowTableResult: 0,
        topicReport: {},
        isShowTopicReportList: [],
        moreSuggestTitle: "",
        moreSuggest: "",
        isShowMoreSuggest: 0,
        reportResult: {},
        isShowReportResult: 0,
        lastImage: [],
        isShowLastImage: []
      },
      topicGroup: [],
      splitText: {},
      htmlTitle: '测评',
      dialogVisible: false
    }
  },
  methods: {
    goEvaluationIndex() {
      this.$router.push({
        path: '/evaluation/index'
      })
    },
    // 获取测试详情
    getTestDetail () {
      request({
        method: 'get',
        url: 'mendao/v2/getTestById',
        params: {
          testId: this.testId
        }
      }).then(res => {
        if (res.code == 0) {
          this.fullscreenLoading = false
          this.testName = res.data.testName
          this.htmlTitle = this.testName;
        } else {
          this.$message.error(res.data.message);
        }
      }).catch((res) => {
      });
    },


    // 获取测评结果详情
    getTestReportDetail () {
      request({
        method: 'post',
        url: 'mendao/v2/showCommitTest',
        data: {
          testId: this.testId,
          id:  this.$route.query.id
        }
      }).then(res => {
        if (res.code == 0) {
          this.fullscreenLoading = false
          let dataObj = JSON.parse(JSON.stringify(res.data));
          this.resultsData = {
            id: dataObj.id,
            testId: dataObj.testId,
            reportDesc: dataObj.reportDesc,
            isShowReportDesc: dataObj.isShowReportDesc,
            tableTitle: dataObj.tableTitle,
            tableSet: dataObj.tableSet,
            isShowTableSet: dataObj.isShowTableSet,
            tableResult: dataObj.tableResult || {},
            isShowTableResult: dataObj.isShowTableResult,
            topicReport: dataObj.topicReport,
            isShowTopicReportList: dataObj.isShowTopicReportList,
            moreSuggestTitle: dataObj.moreSuggestTitle,
            moreSuggest: dataObj.moreSuggest,
            isShowMoreSuggest: dataObj.isShowMoreSuggest,
            reportResult: dataObj.reportResult ? JSON.parse(dataObj.reportResult) : {},
            isShowReportResult: dataObj.isShowReportResult,
            lastImage: dataObj.lastImage ? JSON.parse(dataObj.lastImage) : [],
            isShowLastImage: dataObj.isShowLastImage,
          };

          // 整理题组标题
          if (this.resultsData.topicReport.topicReportList) {
            this.resultsData.topicReport.topicReportList.forEach(e => {
              e.formatTitle = {
                text: e.title
              }
            })
          }

          // moreSuggest
          if (this.resultsData.moreSuggest) {
            this.resultsData.moreSuggest.forEach(e => {
              e.formatTitle = {
                text: e.title
              }
            })
          }
          if (this.resultsData.reportResult.title && this.resultsData.isShowReportResult == 1) {
            this.resultsData.reportResult.formatTitle = {
              text: this.resultsData.reportResult.title
            }
          }
          // console.log('==测评结果==', JSON.stringify(this.resultsData))
          // 图标数据
          this.chartsInfo();
        } else {
          this.$message.error(res.data.message);
        }
      }).catch((res) => {
      });
    },

    // 图表设置
    chartsInfo() {
      // 获取色系 chartThemeColor
      let chartColor = '#c23531';
      if (this.resultsData.tableSet.tableColor) {
        chartColor = this.chartThemeColor[this.resultsData.tableSet.tableColor - 1]
      }

      let baryAxisData = [];
      let barSeriesData = [];
      let radaryAxisData = [];
      let radarSeriesData = [];
      let maxNum = 0;
      for (let i = 0; i < this.resultsData.tableSet.tableTestMsg.length; i++) {
        let item = this.resultsData.tableSet.tableTestMsg[i]
        let yObj = {
          name: `${item.topicGroupCode} ${item.unitName}`,
          max: 5
        };
        if (this.resultsData.tableSet.tableTestMsg[i].unitScore == 'null') {
          this.resultsData.tableSet.tableTestMsg[i].unitScore = '0';
        }
        maxNum = (maxNum - this.resultsData.tableSet.tableTestMsg[i].unitScore) > 0 ? maxNum : this.resultsData.tableSet.tableTestMsg[i].unitScore;
        baryAxisData.push(this.resultsData.tableSet.tableTestMsg[i].unitName);
        barSeriesData.push(this.resultsData.tableSet.tableTestMsg[i].unitScore);
        radaryAxisData.push(yObj);
        radarSeriesData.push(this.resultsData.tableSet.tableTestMsg[i].unitScore);
      }

      radaryAxisData.forEach(e => {
        e.max = maxNum;
      });

      // 获取图标类型
      if (this.resultsData.tableSet.tableName == 2) { // 条形图
        setTimeout(() => {
          this.barChartUtil(chartColor, baryAxisData, barSeriesData);
        }, 100);
      } else if (this.resultsData.tableSet.tableName == 1) { // 雷达图
        setTimeout(() => {
          this.radarChartUtil(chartColor, radaryAxisData, radarSeriesData);
        }, 100);
      }
    },
    // 条形图
    barChartUtil(chartColor, yAxisData, seriesData) {
      let histogramDom = document.getElementById("histogram");
      let histogramChart = this.$echarts.init(histogramDom);
      seriesData = seriesData.reverse();
      yAxisData = yAxisData.reverse();
      histogramChart.setOption({
        color: [chartColor],
        title: {
          text: this.resultsData.tableTitle ? this.resultsData.tableTitle : '图表数据',
          textAlign:'left',
          textStyle: {
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 'normal',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01,],
          max: 100
        },
        yAxis: {
          type: 'category',
          data: yAxisData,
        },
        grid: {
          left: 70
        },
        series: [{
          type: 'bar',
          data: seriesData,
        }]
      }, true);
    },
    // 雷达图
    radarChartUtil(chartColor, yAxisData, seriesData) {
      let histogramDom = document.getElementById("histogram");
      let histogramChart = this.$echarts.init(histogramDom);
      seriesData = seriesData.reverse();
      yAxisData = yAxisData.reverse();

      for (let i=0;i<yAxisData.length;i++) {
        yAxisData[i].max = 10;
      }
      histogramChart.setOption({
        color: [chartColor],
        title: {
          text: this.resultsData.tableTitle ? this.resultsData.tableTitle : '图表数据',
          subtext: '',
          textStyle: {
            fontSize: 14,
            lineHeight: 20,
          },
          // 标题的位置，此时放在图的底边
          left: 'center',
          top: 'top',
        },
        tooltip: {},
        radar: {
          name: {
            textStyle: {
              color: 'rgba(0,0,0,0.8)',
              fontSize: 16,
              // backgroundColor: '#999',
              borderRadius: 3,
              padding: [3, 5],
              textAlign: "center"
            }
          },
          indicator: yAxisData
        },
        series: [{
          type: 'radar',
          data: [
            {
              value: seriesData,
              name: this.resultsData.tableTitle,
              label: {
                normal: {
                  show: true,
                  formatter: function (params) {
                    return params.value
                  }
                }
              }
            }
          ]
        }]
      }, true);
    },

    // 下载pdf
    getPdf(url) {
      let title = this.htmlTitle
      html2Canvas(document.querySelector(url), {
        allowTaint: true,
        taintTest: false,
        logging: false,
        useCORS: true,
        dpi: window.devicePixelRatio * 1.5, //将分辨率提高到特定的DPI 提高四倍
        // dpi:300,
        scale: 1.5 //按比例增加分辨率
      }).then(canvas => {
        var pdf = new JsPDF('p', 'mm', 'a4');    //A4纸，纵向

        var ctx = canvas.getContext('2d'),
          a4w = 260, a4h = 280,    //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
          imgHeight = Math.floor(a4h * canvas.width / a4w),    //按A4显示比例换算一页图像的像素高度
          renderedHeight = 0;
        ctx.mozImageSmoothingEnabled = false;
        ctx.webkitImageSmoothingEnabled = false;
        ctx.msImageSmoothingEnabled = false;
        ctx.imageSmoothingEnabled = false;
        while (renderedHeight < canvas.height) {
          var page = document.createElement("canvas");
          page.width = canvas.width;
          page.height = Math.min(imgHeight, canvas.height - renderedHeight);//可能内容不足一页

          //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
          page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0);
          pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', -25, 10, a4w, Math.min(a4h, a4w * page.height / page.width));    //添加图像到页面，保留10mm边距

          renderedHeight += imgHeight;
          if (renderedHeight < canvas.height) {
            pdf.addPage();//如果后面还有内容，添加一个空页
          }
        }
        //保存文件
        pdf.save(title + '.pdf')

      })
    },

    openConsult () {

    }


  },
  created () {
    this.testId = this.$route.query.testId;
    this.getTestDetail();
    this.getTestReportDetail();
  }
}
</script>

<style lang="stylus">
.evaluation-result
  .el-dialog__title
    font-weight 700
</style>
<style scoped lang="stylus">
pageWidth = 1400px
$color-background = #fff
$color-background-d = rgba(0, 0, 0, 0.3)
$color-highlight-background = #333
$color-dialog-background = #666
$color-theme = #e96558
$color-theme-d = rgba(233, 101, 88, 0.5)

$color-text = #fff
$color-text-e = rgba(0, 0, 0, 0.1)
$color-text-d = rgba(0, 0, 0, 0.3)
$color-text-l = rgba(0, 0, 0, 0.5)
$color-text-ll = rgba(0, 0, 0, 0.8)

//字体定义规范
$font-size-small-s = 10px
$font-size-small = 12px
$font-size-medium = 14px
$font-size-medium-x = 16px
$font-size-large = 18px
$font-size-large-l = 20px
$font-size-large-x = 22px

div
  box-sizing: border-box

.evaluation-result
  width pageWidth
  margin 0 auto
  padding 20px 0
  font-size $font-size-medium
  color $color-text-ll
  word-wrap break-word
  word-break break-all
  background #fff

  table, tr, td, th, tbody, thead, tfoot, img
    page-break-inside: avoid !important;

  .m-t-20
    margin-top 20px

  #pdfDom
    background: #fff

  .result-section
    padding: 0 15%

  .user-info
    font-size: 14px

  .user-info-tip
    font-size 14px
  /*color $color-theme*/

  .txt-c
    text-align center

  .title-set
    font-size $font-size-large-l
    font-weight 600

  .summary-title
    font-size $font-size-large

  .subtitle-set
    font-size $font-size-large

  .test-report
    font-size: $font-size-medium-x
    line-height 28px
    font-weight 600

  .histogram-section
    width: 100%
    height: 650px

  .chart-summary
    padding: 20px 10px
    border-radius: 4px
    border: 1px solid #dcdfe6
    background: rgba(0, 0, 0, 0.05)

  .summary-txt
    padding-top: 12px
    line-height 28px
    text-indent: 2em;
    font-size: $font-size-medium-x

  .result-img-list
    padding: 20px
    img
      display block
      max-width 100%
      margin: 0 auto
      margin-bottom: 5px

  .btn-box
    padding: 20px 0
    text-align center

  .consult-content
    color: #333
    text-align center
    p
      padding 6px 0
      font-weight 700
    .title
      font-size 18px
      font-weight 700


.right-btn-box
  position: fixed;
  top: 50%;
  margin-top: -120px;
  right: 10px;
  width: 60px;
  .el-button
    width: 60px;
    height: 60px;
    padding: 0;
    margin-bottom: 20px;
    text-align center
    color: #fff;
  .el-button+.el-button
    margin-left: 0;
</style>
